<template>
  <invoice-form
    :form-data.sync="formData"
    :loading="isLoading"
    @submit="onSubmit"
    @cancel="onCancel"
  />
</template>

<script>
import Logo from '@core/layouts/components/Logo.vue';
import { ref, onUnmounted, watch } from '@vue/composition-api';
import Ripple from 'vue-ripple-directive';
import store from '@/store';
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BOverlay,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useToast } from 'vue-toastification/composition';

import InvoiceForm from '../invoice-form/InvoiceForm.vue';
import invoiceStoreModule from '../invoiceStoreModule';
import router from '@/router';
import { generateRandomString } from '@/utils/functions';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    BOverlay,
    flatPickr,
    vSelect,
    Logo,
    InvoiceForm,
    ToastificationContent,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  setup() {
    const toast = useToast();

    const INVOICE_APP_STORE_MODULE_NAME = 'sales-invoice';

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
      store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
        store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME);
    });

    const isLoading = ref(false);
    const formData = ref(null);

    // watch(
    //   formData,
    //   (newVal) => {
    //     console.log('=== formData', JSON.stringify(newVal, null, 2));
    //   },
    //   {
    //     deep: true,
    //   }
    // );

    const onSubmit = async () => {
      console.log('=== Invoice Add On Submit', JSON.stringify(formData.value, null, 2));

      isLoading.value = true;

      store
        .dispatch('sales-invoice/addInvoice', {
          ...formData.value,
          entity: {
            ...formData.value.entity,
            docNo: generateRandomString(),
          },
        })
        .then((response) => {
          console.log('=== Invoice Add On Submit Response', response);

          toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: 'Invoice Added Successfully',
            },
          });

          router.push({ name: 'sales-invoice-view', params: { id: response.entity.id } });
        })
        .catch((error) => {
          console.error('Error adding invoice:', error);

          toast({
            component: ToastificationContent,
            props: {
              title: 'Error Adding Invoice',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: error.message,
            },
          });
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const onCancel = () => {
      router.go(-1);
    };

    return {
      isLoading,
      formData,
      onSubmit,
      onCancel,
    };
  },
};
</script>
